import axios from "axios";
import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import { getErrorBlob } from "helpers/extractError";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { reportCarburetionTypes } from "redux/reducers/Reports/reportCarburetion/types";

const { SET_REPORT_CARBURETION_FILTERS } = reportCarburetionTypes;

export const getReportCarburetionAction = ({ startDate, endDate, station, isPdf = true }) => {
  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user');
    const auth = { headers: { authorization: token } };
    const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/carburations/report-per-station/${station.id}?initDate=${startDate}&endDate=${endDate}&pdf=${isPdf}`;
    const fileName = `Reporte_Carburación_${station.name}_${startDate}_${endDate}.${isPdf ? `pdf` : `xlsx`}`;

    dispatch(startRequestComp('loadingReportCarburetion'));
    const access = {
      url: reportUrl,
      method: 'GET',
      responseType: 'blob',
      ...auth,
    };
    try {
      const pdf = await axios(access);
      saveAs(pdf.data, fileName);
      dispatch(setSnackbar(`${isPdf ? `PDF` : `Excel`} Descargado con éxito`, "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp('loadingReportCarburetion'));
    }
  };
};

export const setReportCarburetionFilters = (key = "", value) => {
  return {
    type: SET_REPORT_CARBURETION_FILTERS,
    payload: { value, key },
  };
};
